import { useTranslation } from 'react-i18next';
import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { styled } from '@mui/material';

export type DeleteGroupDialogProps = {
  open: boolean;
  onClose: () => void;
  handleConfirmDelete: () => void;
  groupName: string;
};

const StyledDiv = styled('div')({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});

const StyledHeader = styled(TextV2)({
  fontSize: '18px !important',
});

const StyledSubHeader = styled(TextV2)({
  margin: `0.25rem 0 0 !important`,
});

const DeleteGroupDialog = ({
  open,
  onClose,
  handleConfirmDelete,
  groupName,
}: DeleteGroupDialogProps) => {
  const { t } = useTranslation();

  const content = (
    <StyledDiv>
      <StyledHeader variant="bodyBold">
        {t('ui.event-management.manage-group.confirm-delete.body-text', {
          groupName: groupName ?? '',
        })}
      </StyledHeader>
      <br />
      <StyledSubHeader>
        {t('ui.event-management.manage-group.confirm-delete.description')}
      </StyledSubHeader>
    </StyledDiv>
  );
  const title = t('ui.event-management.manage-group.confirm-delete.title');
  const confirmText = t(
    'ui.event-management.manage-group.confirm-delete.confirm-button',
  );
  const cancelText = t(
    'ui.event-management.manage-group.confirm-delete.cancel-button',
  );
  return (
    <Dialog
      dialogProps={{
        title,
        onClose,
        maxWidth: 'md',
      }}
      title={title}
      content={content}
      open={open}
      primaryButtonText={confirmText}
      secondaryButtonText={cancelText}
      onSubmit={handleConfirmDelete}
      onClose={onClose}
      primaryButtonColour="error"
    />
  );
};

export default DeleteGroupDialog;
